import AbcIcon from "@mui/icons-material/Abc"
import CandlestickChartIcon from "@mui/icons-material/CandlestickChartOutlined"
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter"
import ShowChartIcon from "@mui/icons-material/ShowChart"
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart"
import {
  Avatar,
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Select,
  Switch,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material"
import { styled, useTheme } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import {
  getChartOptionsData,
} from "../../../common/utility/configData"
import { captureChartInteraction } from "../../../analytics/chartsTool"
import {
  OF_TIME_FRAME,
  PROFILE_VIEW,
  ROTATING_COT_LIST,
  TEXT_MSGS,
  USER_RESOURCES_LIST,
  USER_ROLE_FIELDS,
} from "../../../common/utility/constant"
import {
  CHART_TYPE,
  ROTATING_COT_VAL,
  VA_TYPE,
  VP_TYPE,
} from "../../../common/utility/mp_chart_constants"
// import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert"
import ScoreOutlinedIcon from "@mui/icons-material/ScoreOutlined"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from '@mui/icons-material/Settings';
import { getTimeFrameForLineChart, isCOTChangeAllowed, isD3BasedLineChart, isChartOptionAccessAllowed } from "../../../common/utility/helperFunc"
import useAuth from "../../../common/hooks/useAuth"
// ============================================================
// NEW - Role-based Permission System
// See: src/common/utility/roleController.js
// ============================================================
import { useRoleController } from "../../../common/utility/roleController";
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from "../../../common/hooks/usePermissions";
import { FEATURES } from "../../../common/utility/featurePermissions";
import VisibilityIcon from '@mui/icons-material/Visibility';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ITEM_HEIGHT = 48
const ITEM_HEIGHT_NEW = 26
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT_NEW * 10 + ITEM_PADDING_TOP,
      width: 120,
      autoFocus: false,
    },
  },
}

export const FooterToolbar = styled(Toolbar)(
  ({ theme }) => `
    background-color:${theme.palette.primaryTheme.shade01};
    width:100%;
    height:32px;
    text-align:center;
    flex-shrink:0;
    ${theme.breakpoints.up("mobile")}{
      min-height:32px;
    }
   `
)

/**
 *
 * @returns fixed toolbar for copyright text
 */
function LineChartFooterNew(props) {
  const theme = useTheme()
  // ============================================================
  // NEW - Role-based Permission System
  // See: src/common/utility/roleController.js
  // ============================================================
  const roleController = useRoleController();
  
  const [userSettings, setUserSettings] = useState(props.userSettings)
  const [selectedInstrumentData, setSelectedInstrumentData] = useState(
    props.selectedInstrumentData
  )

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  
  const [chartOptionsData, setChartOptionsData] = useState(
    getChartOptionsData(props.auth)
  )

useEffect(() => {
    setChartOptionsData(getChartOptionsData(props.auth));
}, [props.auth]);
  // ============================================================
  // NEW - Role-based permission checks
  // See: src/common/utility/roleController.js
  // Note: Orderflow features accessible based on role only (PRO1 = Elite tier)
  // No resource enforcement for orderflow_index/orderflow_stocks
  // ============================================================
  const [isStocksAllowed, setIsStocksAllowed] = useState(
    roleController.can(FEATURES.OF_CHART_STOCKS)
  )
  const [isIndexAllowed, setIsIndexAllowed] = useState(
    roleController.can(FEATURES.OF_CHART_INDEX)
  )

  const [selectedTimeFrame,setSelectedTimeFrame]=useState(props.selectedInstrumentData?.of?props.timeFrame:"1");
  const [timeFrames,setTimeFrames]=useState(getTimeFrameForLineChart(props.plotData?.plot, props.plotData?.doix, props.selectedInstrumentData?.of));
  const [selectedCot,setSelectedCot]=useState(props.selectedCot);
  const [cotList,setCotList]=useState(ROTATING_COT_LIST);
  const { auth } = useAuth()
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  // PRO2-only feature 
  const isPro2User = permissions.isPro2User();
  const [panel1Visible,setPanel1Visible]=useState(props.panel1Visible);
  const [biToggleEnabled,setBiToggleEnabled]=useState(props.biToggleEnabled !== undefined ? props.biToggleEnabled : true);
  const [volxLinesToggleEnabled,setVolxLinesToggleEnabled]=useState(() => {
    const initialValue = props.volxLinesToggleEnabled !== undefined ? props.volxLinesToggleEnabled : false;
    return initialValue;
  });

  useEffect(() => {
    if (props.biToggleEnabled !== undefined) {
      setBiToggleEnabled(props.biToggleEnabled);
    }
  }, [props.biToggleEnabled]);

  useEffect(() => {
    if (props.volxLinesToggleEnabled !== undefined) {
      setVolxLinesToggleEnabled(props.volxLinesToggleEnabled);
    }
  }, [props.volxLinesToggleEnabled]);

  const handlePanel1Toggle = () =>{
    console.log("Panel1 test footer handleToggle val=",panel1Visible,!panel1Visible)
    props.changePanel1Visibility(!panel1Visible);
    setPanel1Visible((prev) => !prev);
    }

  const handleBiToggle = () =>{
    setBiToggleEnabled((prev) => !prev);
    if(props.changeBiToggle){
      props.changeBiToggle(!biToggleEnabled);
    }
    }

  const handleVolxLinesToggle = () =>{
    const newValue = !volxLinesToggleEnabled;
    setVolxLinesToggleEnabled(newValue);
    if(props.changeVolxLinesToggle){
      props.changeVolxLinesToggle(newValue);
    }
  }

  useEffect(()=>{
    console.log("LCFooter props and TF=",props,props.timeFrame)
    if(!cotList.includes(selectedCot)){
      setCotList([selectedCot,...cotList]);
    }
  },[])

  useEffect(()=>{
    // console.log("Panel1 test footer useEffect val=",panel1Visible)
    // props.changePanel1Visibility(panel1Visible);
    setPanel1Visible(props.panel1Visible)
  },[props.panel1Visible])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (event, index) => {
    setAnchorEl(null)
    if (index >= 0) {
      const option = chartOptionsData[index]
      if (!isChartOptionAccessAllowed(permissions, option)) {
        props.openSubscribeModal()
        return
      }
      console.log(
        "event.target.value menu=======>",
        event.target.value,
        option,
        index
      )
      props.handleChartChange(option)
    }
  }

  const openLineChart = () => {
    if (props.basicUser) props.openSubscribeModal()
    else props.openLineChart()
  }

  const openOFChart = () => {
    if (
      !isStocksAllowed &&
      selectedInstrumentData.resource &&
      selectedInstrumentData.resource == "stocks"
    ) {
      props.openSunscriptionModal(
        true,
        TEXT_MSGS.OF_CHART_STOCKS_RESOURCE_NOT_SUBSCRIBED_DESC
      )
      return
    } else if (
      !isIndexAllowed &&
      selectedInstrumentData.resource &&
      selectedInstrumentData.resource == "index"
    ) {
      props.openSunscriptionModal(
        true,
        TEXT_MSGS.OF_CHART_INDEX_RESOURCE_NOT_SUBSCRIBED_DESC
      )
      return
    } else props.openOFChart()
  }

  const openMPChart = () => {
    props.openMPChart()
  }

  useEffect(() => {
    console.log("StraddleTest LCContainer 4 00 Footer",props.selectedInstrumentData,props.timeFrame)
    setSelectedInstrumentData(props.selectedInstrumentData)
  }, [props.selectedInstrumentData])

  const openSettings=()=>{
    props.openSettings();
  }

  const changeTimeFrame=(val)=>{
    if(val!=selectedTimeFrame){
      captureChartInteraction('charts_timeframe_changed', { timeframe: val });
      setSelectedTimeFrame(val);
      props.changeTimeFrame(val);
    }
  }

  useEffect(()=>{
    console.log("StraddleTest LCContainer 4 Footer",selectedInstrumentData,props.selectedInstrumentData,props.timeFrame)
    setSelectedTimeFrame(props.selectedInstrumentData.of?props.timeFrame:"1");
  },[props.timeFrame])
  
useEffect(()=>{
  setTimeFrames(getTimeFrameForLineChart(props.plotData?.plot, props.plotData?.doix, props.selectedInstrumentData?.of));
},[props.plotData,props.selectedInstrumentData])
  
useEffect(()=>{
  setSelectedCot(props.selectedCot);
},[props.selectedCot])

const handleCotChange = (event) => {
  // console.log("TPO selected=",event.target);
  setSelectedCot(event.target.value);
  props.cotChanged(Number(event.target.value));
  
};

  const plotData = props.plotData ?? { plot: "", doix: false }
  const showChartSettings =
    props.chartType === CHART_TYPE.BAR_CHART ||
    (props.chartType === CHART_TYPE.LINE_CHART &&
      (selectedInstrumentData?.of ||
        isD3BasedLineChart(plotData.plot, plotData.doix)))

  return (
    <>
      <FooterToolbar
        sx={{
          paddingLeft: "4px",
          paddingRight: "8px",
          borderTop: `1px solid ${theme.palette.primaryTheme.shade03}`,
          width: "100%",
          minHeight: "32px",
          zIndex: 20,
          pointerEvents: "auto",
          ...(props.embedded
            ? { position: "relative" }
            : {
                position: "absolute",
                left: 0,
                bottom: 0,
                top: "auto",
              }),
        }}
      >
        <>
          <Box
            display="flex"
            sx={{
              height: "100%",
              overflowX: "auto",
              overflowY: "hidden",
              width: `calc(100% - 160px)`,
              alignItems: "center",
            }}
          >
            {showChartSettings ? (
                <Tooltip
                    title={
                        plotData.plot === "spt_ivr"
                            ? "IV Range Chart Settings"
                            : props.chartType === CHART_TYPE.LINE_CHART
                              ? "Line Chart Settings"
                              : "Bar Chart Settings"
                    }
                >
                    <SettingsIcon
                        onClick={openSettings}
                        sx={{
                            ml: "2px",
                            marginRight: "6px",
                            marginTop:
                                props.chartType === CHART_TYPE.MARKET_PROFILE
                                    ? "-3px"
                                    : "-3px",
                            cursor: "pointer",
                        }}
                    />
                </Tooltip>
            ) : null}
{props.showTimeFrame && isD3BasedLineChart(plotData.plot, plotData.doix)?
<>
{timeFrames.filter(obj=>{
                return true;
                  // if(!props.basicUser)
                  //   return true;
                  // else
                  //   return obj.value!=OF_TIME_FRAME_VALUES.tf_15_min
                  // return props.selectedInstrumentData.tf.includes(obj.value) && obj.value!=TIME_FRAME_VALUES.yearly  //dont show yearly time frame for basic user
                  
            }).map((item,index) => (
                            <Tooltip title={item.displayText}>
                            <Button  variant="text" key={item.key} onClick={()=>changeTimeFrame(item.value)}
                            sx={{minWidth:50,fontSize:14,width:50,height:30,borderRadius:0,marginBottom:"8px",marginTop:1,
                            backgroundColor:selectedTimeFrame==item.value?"#567":"transparent",
                            "&:hover": {
                              backgroundColor: '#567'
                            }}}>
                            {item.value}
                            </Button>
                            </Tooltip>
                        ))}
              </>:
              <></>
              } 
              {/* {isPro2User && isCOTChangeAllowed(props.plotData.plot,props.plotData.doix)?
            <Box display="flex"  justifyContent="flex-start" alignContent="center" alignItems="center" >
                <Typography variant='lableTextSettings' sx={{fontSize:12,ml:2}}>{"nbCOT "}</Typography>
                <FormControl variant="standard" size="small" sx={{ml:1, minWidth:"70px",height:"58%" }}>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={selectedCot}
                        onChange={handleCotChange}
                        label="TPO Size"
                        sx={{textAlign:"center",width:50,paddingTop:"4px"}}
                        // MenuProps={MenuPropsTPO}
                        >
                        {cotList.map((item,index) => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                </Box>:
                <></>
                }          */}
                
            <Typography sx={{ fontSize: 14, ml: 2, mt: 0 }}>Charts</Typography>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
              size="small"
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={(event) => handleClose(event, -1)}
              sx={{ zIndex: theme.zIndex.modal }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "22ch",
                },
              }}
            >
              {chartOptionsData.map((option, index) => (
                <MenuItem
                  key={option.key}
                  onClick={(event) => handleClose(event, index)}
                >
                  {option.key}
                </MenuItem>
              ))}
            </Menu>
            {/* Volx Lines Toggle Button */}
            {plotData.plot=="all_volx"? 
            <Tooltip title="Volx Lines: On=Live Intraday data lines Only, Off=All historical data lines visible">
            <Button
              variant="text"
              onClick={()=>{
                handleVolxLinesToggle();
              }}
              sx={{
                minWidth:40,
                fontSize:12,
                width:40,
                height:30,
                borderRadius:0,
                marginBottom:"8px",
                marginTop:1,
                marginLeft:1,
                backgroundColor: volxLinesToggleEnabled ? "#567" : "transparent",
                "&:hover": {
                  backgroundColor: volxLinesToggleEnabled ? '#789' : '#567'
                }
              }}
            >
              {'iVolx'}
            </Button>
            </Tooltip>:
            <></>
            }
            {/* BI Toggle Button - Balance/Imbalance Boxes */}
            {(plotData.plot=="fut"|| plotData.plot=="opt") && (plotData.doix!="1")? 
            <Tooltip title="Toggle Balance/Imbalance Boxes">
            <Button
        variant="text"
        onClick={()=>handleBiToggle()}
        sx={{
          minWidth:40,
          fontSize:12,
          width:40,
          height:30,
          borderRadius:0,
          marginBottom:"8px",
          marginTop:1,
          marginLeft:1,
          backgroundColor:(() => {
            console.log("=== BI TOGGLE DEBUG === BI BUTTON - biToggleEnabled:", biToggleEnabled);
            console.log("=== BI TOGGLE DEBUG === Button background color:", biToggleEnabled ? "#567" : "transparent");
            return biToggleEnabled ? "#567" : "transparent";
          })(),
          "&:hover": {
            backgroundColor: biToggleEnabled ? '#789' : '#567'
          }
        }}
      >
        {'BI'}
      </Button></Tooltip>:
      <></>
            }
            {/* {(props.plotData.plot=="fut"|| props.plotData.plot=="opt") && (props.plotData.doix!="1" || props.plotData.doix==false )?  */}
            {(plotData.plot=="fut"|| plotData.plot=="opt") && (plotData.doix!="1")? 
            <Tooltip title="Control Panel visibility and other options (Note these changes are not saved - to permanently save the settings, use the Settings section)">
            <Button
        variant="text"
        onClick={()=>handlePanel1Toggle()}
        endIcon={!panel1Visible ? <VisibilityIcon /> : <VisibilityIcon />}
      >
        {'Panel Controls'}
      </Button></Tooltip>:
      <></>
            }
            {/* Panel Controls for Volx chart */}
            {plotData.plot=="all_volx"? 
            <Tooltip title="Control Panel visibility and other options (Note these changes are not saved - to permanently save the settings, use the Settings section)">
            <Button
        variant="text"
        onClick={()=>handlePanel1Toggle()}
        endIcon={!panel1Visible ? <VisibilityIcon /> : <VisibilityIcon />}
      >
        {'Panel Controls'}
      </Button></Tooltip>:
      <></>
            }
          </Box>
        </>
        <Box
          display="flex"
          justifyContent="flex-end"
          sx={{ height: "100%", width: "170px", alignItems: "center" }}
        >
          {/* {selectedInstrumentData.line_chart ? (
           <Tooltip title={props.isEliteUser?"Candle Chart":"Line Chart"}>
              <ShowChartIcon
                onClick={openLineChart}
                sx={{
                  border: "0.5px solid",
                  ml: 1,
                  marginTop:
                    props.chartType == CHART_TYPE.MARKET_PROFILE
                      ? "-3px"
                      : "-3px",
                  height: 20,
                  width: 20,
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          ) : (
            <></>
          )} */}
          {props.isEliteUser ?
            <>
              {selectedInstrumentData?.cc ?
                <Tooltip title={"Candle Chart"}>
                  <ShowChartIcon onClick={openLineChart} sx={{ border: "0.5px solid", ml: 1, marginTop: props.chartType == CHART_TYPE.MARKET_PROFILE ? "-3px" : "-3px", height: 20, width: 20, cursor: 'pointer' }} />
                </Tooltip> :
                <></>
              }
            </> :
            <>
              {selectedInstrumentData?.line_chart ?
                <Tooltip title={"Line Chart"}>
                  <ShowChartIcon onClick={openLineChart} sx={{ border: "0.5px solid", ml: 1, marginTop: props.chartType == CHART_TYPE.MARKET_PROFILE ? "-3px" : "-3px", height: 20, width: 20, cursor: 'pointer' }} />
                </Tooltip> :
                <></>
              }
            </>
          }
          {selectedInstrumentData?.of ? (
            <Tooltip title="Orderflow Chart">
              <ScoreOutlinedIcon
                onClick={openOFChart}
                sx={{
                  border: "0.5px solid",
                  ml: 1,
                  marginTop:
                    props.chartType == CHART_TYPE.MARKET_PROFILE
                      ? "-3px"
                      : "-3px",
                  height: 20,
                  width: 20,
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          ) : (
            <></>
          )}

          <Tooltip title="MP chart">
            <AbcIcon
              // disabled
              onClick={openMPChart}
              sx={{
                border: "0.5px solid",
                ml: 1,
                marginTop:
                  props.chartType == CHART_TYPE.MARKET_PROFILE
                    ? "-3px"
                    : "-3px",
                height: 20,
                width: 20,
                cursor: "pointer",
              }}
            ></AbcIcon>
          </Tooltip>
        </Box>
      </FooterToolbar>
    </>
  )
}

export default LineChartFooterNew

